<script>
import NavBarPrimaryRoutes from '@components/nav-bar/nav-bar-primary-routes.vue';
import { authComputed, orgComputed, orgMethods} from '@src/state/helpers';
import resize from '@utils/image-sizer';
const appConfig = require('@src/app.config');

export default {
  components: {
    NavBarPrimaryRoutes,
  },
  props: {
    transparent: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loggedInNavRoutes: [
        {
          name: 'home',
          title: 'Fitness',
        },
        {
          name: 'nutrition',
          title: 'Nutrition',
        },
        {
          name: 'Info',
          title: 'Profile',
        },
      ],
    };
  },
  computed: {
    ...authComputed,
    ...orgComputed,
    avatar() {
      return this.userProfile &&
        this.userProfile.mediaAssets &&
        this.userProfile.mediaAssets.avatarImage &&
        this.userProfile.mediaAssets.avatarImage.url
        ? resize(this.userProfile.mediaAssets.avatarImage.url, 60, 60)
        : '';
    },
    logoUrlDark() {
      return appConfig.ORG_ID === '618183d65e84466f63c38878'
        ? 'https://tandem-email.s3.amazonaws.com/pmeo-logo-dark.png'
        : 'https://tandem-email.s3.amazonaws.com/smartfitness-logo-dark.png';
    },
    logoUrl() {
      return appConfig.ORG_ID === '618183d65e84466f63c38878'
        ? 'https://tandem-email.s3.amazonaws.com/pmeo-logo-dark.png'
        : 'https://tandem-email.s3.amazonaws.com/smartfitness-logo.png';
    },
    siteName(){
      return this.sitename;
    },
    // siteLogoImage() {
    //   return this.darkLogoUrl;
    // },
  },
  methods: {
    ...orgMethods,
    toHome() {
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
    },
    toProfile() {
      if (this.$route.name !== 'profile') {
        this.$router.push({ name: 'Info' });
      }
    },
  },
};
</script>

<template>
  <div :class="['navbar-wrapper', { transparent: transparent, isNutrition: $route.name === 'nutrition' }]">
    <div class="logo" @click="toHome">
      <img v-if="!transparent" :src="logoUrlDark" :alt="siteName" />
      <img v-else svg-inline :src="logoUrl" />
    </div>

    <div class="navbar-links">
      <ul class="list-navbar-links">
        <NavBarPrimaryRoutes v-for="(route, i) in loggedInNavRoutes" :route="route" :key="i" />
      </ul>
      <div class="avatar" :style="{ 'background-image': `url(${avatar})` }" @click="toProfile">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-user'" v-if="!avatar" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6 .667A2.667 2.667 0 116 6 2.667 2.667 0 016 .667zM6 2a1.333 1.333 0 100 2.667A1.333 1.333 0 006 2zm0 4.667c1.78 0 5.333.887 5.333 2.667v2H.667v-2C.667 7.554 4.22 6.667 6 6.667zm0 1.267c-1.98 0-4.067.973-4.067 1.4v.733h8.133v-.733c0-.427-2.086-1.4-4.066-1.4z" fill="#000"/></svg>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.navbar-wrapper {
  align-items: center;
  background-color: white;
  display: flex;
  height: 6rem;
  justify-content: space-between;
  padding-left: 5vw;
  padding-right: 5vw;
  position: relative;
  z-index: 10;
  &.isNutrition {
    left: 0;
    position: fixed;
    right: 0;
  }
  .logo {
    cursor: pointer;
    img {
      width: 176.9px;
    }
  }
  .navbar-links {
    align-items: center;
    display: flex;
    justify-content: space-between;

    .list-navbar-links {
      margin-bottom: 0;
    }

    ::v-deep li {
      a {
        font-size: 1.7rem;
        text-decoration: none;
      }

      &.router-link-active a {
        border-bottom: 3px solid var(--color);
        padding-bottom: 0.5rem;
      }
    }

    .avatar {
      align-items: center;
      background-color: lightgray;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      height: 4.2rem;
      justify-content: center;
      margin-left: 7.3rem;
      width: 4.2rem;

      img {
        width: 100%;
      }

      .icon-user {
        height: 2rem;
        width: auto;

        path {
          fill: gray;
        }
      }
    }
  }

  &.transparent {
    background-color: transparent;
    left: 0 !important;
    position: absolute !important;
    right: 0 !important;
    .navbar-links {
      ::v-deep li {
        a {
          color: white;
          text-decoration: none;
        }

        a:hover {
          color: var(--color);
        }

        &.router-link-active a {
          border-bottom: 3px solid $color-blue-alt;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
}
</style>
